
<dialog #ficheGenerique>
  <div class="val-fiche-generique val-flex-conteneur val-flex-colonne">
    <div class="val-fiche-generique-entete val-flex-conteneur">
      <div class="val-fiche-generique-entete-libelle val-flex-1">
        <val-simple-libelle [libelle]="titre"></val-simple-libelle>
      </div>
      <div>
        <ng-content select="[menu]"></ng-content>
      </div>
      <div class="val-fiche-generique-entete-commandes val-flex-conteneur">
        <div class="val-fiche-generique-entete-commande"
             [ngClass]="{'val-invisible': !fermerVisible}"
             (click)="EnvoyerFermer()">
          <val-fonte-icone iconeCss="fas fa-times"></val-fonte-icone>
        </div>
      </div>
    </div>
    <div class="val-fiche-generique-bandeau">
      <ng-content select="[bandeau]"></ng-content>
    </div>
    <div class="val-fiche-generique-contenu val-flex-1">
      <ng-content select="[contenu]"></ng-content>
    </div>
    <div class="val-fiche-generique-bandeau-bas">
      <ng-content select="[bandeau-bas]"></ng-content>
    </div>
  </div>
</dialog>
